import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    info: null, // 用户信息
    city: null,
    site: null,
    cityinfo: null,
  },
  mutations: {
    setInfo(state, info) {
      state.info = info;
    },
    setSite(state, info) {
      state.site = info;
    },
    setCity(state, info) {
      state.city = info;
    },
    setCityInfo(state, info) {
      state.cityinfo = info;
    },
    clearInfo(state) {
      state.info = null;
    },
  },
  actions: {
    async getInfo({ state }) {
      return state.info;
    },
    async getSite({ state }) {
      return state.site;
    },
    async getSate({ state }) {
      return state;
    },
  },
});

export default store;
